module.exports = __webpack_public_path__ + "img/ttb.c1b79645.jpg";